import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { TreeNode } from "primeng/primeng";

import { MessageComponent } from "../shared/component/message/message.component";
import { ReturnMessageModel } from "../shared/model/return-message.model";
import { UserTypeService } from "../shared/service/user-type.service";
import { UserTypeModel } from "../shared/model/user-type.model";
import { UserService } from '../shared/service/user.service';
import { MenuService } from "../shared/service/menu.service";
import { AccessRules } from '../shared/enum/access_rules';
import { MenuModel } from "../shared/model/menu.model";

@Component({
  selector: "app-user-type",
  templateUrl: "./user-type.component.html",
  styleUrls: ["./user-type.component.css"],
})
export class UserTypeComponent implements OnInit {
  @ViewChild(MessageComponent) message: MessageComponent;

  lastEvent: any;

  totalRecords: number;

  accessRules: any[] = [];

  menus: TreeNode[] = [];  
  selectedMenus: TreeNode[] = [];
  userTypes: UserTypeModel[] = [];

  userType: UserTypeModel = new UserTypeModel();
  currentUserType: UserTypeModel = new UserTypeModel();

  constructor(
    private menuService: MenuService,
    private userService: UserService,
    private userTypeService: UserTypeService,
    private translateService: TranslateService
  ) {
    this.menuService.getPaginated(0, 1000).subscribe((result) => {
      result.rows.forEach((item: MenuModel) => {
        let menu = {
          label: this.translate(item.translate || item.name),
          data: item.id,
          children: [],
        };
        if (item.children_menus && item.children_menus.length > 0) {
          menu.children = [];
          item.children_menus.forEach((subItem) => {
            menu.children.push({
              label: this.translate(subItem.translate || subItem.name),
              data: subItem.id,
            });
          });
        }

        this.menus.push(menu);
      });
    });
  }

  ngOnInit() {
    this.getUserType();
    this.getListOptions();
  }

  lazy(e) {
    this.lastEvent = e;
    this.userTypeService
      .getPaginated(e.first, e.rows)
      .subscribe((userTypes) => {
        this.userTypes = userTypes["rows"] as UserTypeModel[];
        this.totalRecords = userTypes["count"];
      });
  }

  onSelect(e) {
    this.selectedMenus = [];

    this.userType = e.data;

    this.menus.forEach((item) => {
      let qt = 0;
      if (item.children.length > 0) {
        item.children.forEach((subItem) => {
          if (e.data.menu_ids.includes(subItem.data)) {
            this.selectedMenus.push(subItem);
            qt++;
          }
        });

        item.partialSelected = qt && item.children.length > qt ? true : false;
      }

      if (e.data.menu_ids.includes(item.data) && !item.partialSelected) {
        this.selectedMenus.push(item);
      }
    });
  }

  onSave() {
    let menuIds: number[] = [];
    this.selectedMenus.forEach((item) => {
      if (!menuIds.includes(item.data)) {
        menuIds.push(item.data);

        if (item.parent && !menuIds.includes(item.parent.data)) {
          menuIds.push(item.parent.data);
        }
      }
    });

    this.userType.menu_ids = menuIds;

    this.userTypeService
      .save(this.userType)
      .subscribe((r: ReturnMessageModel) => {
        if (r.error) {
          this.message.error(this.translate(r.message));
        } else {
          this.message.success(r.message);
          this.selectedMenus = [];
        }
        this.lazy(this.lastEvent);
        this.onNew();
      });
  }

  onDelete() {
    this.userTypeService
      .delete(this.userType.id)
      .subscribe((r: ReturnMessageModel) => {
        if (r.error) this.message.error(this.translate(r.message));
        else this.message.success(this.translate(r.message));
        this.lazy(this.lastEvent);
        this.onNew();
      });
  }

  onChangeOperator(e) {
    console.log(e);
  }

  onNew() {
    this.selectedMenus = [];

    this.menus.forEach((item) => {
      item.partialSelected = false;
    });

    this.userType = new UserTypeModel({ 
      // access_rule: AccessRules['level_iii']
    } as UserTypeModel);
  }

  isOperator() {
    if (this.userType.access_rule == AccessRules['level_iv']) {
      this.userType.is_operator = true;
    }
  }

  getUserType() {
    this.userService.getCurrentUserData().subscribe((res) => {
      if (res) this.currentUserType = res.user_type;
    })
  }

  validate(): boolean {
    return UserTypeModel.validate(this.userType);
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");

  tUpper = (key) => this.translate(key).toString().toUpperCase();
  tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

  getListType = (id) => AccessRules[id] || 'selection';

  getListOptions() {
    const listKeys = Object.keys(AccessRules);
    const listOptions = listKeys.map((n) => parseInt(n)).filter(v => v && v >= AccessRules['level_i']) as number[];

    this.translateService.get('translate_version').subscribe(_ => {   

      listOptions.forEach((value)=> {
        const realName = AccessRules[value];
        const label = this.translate(realName) || 'N/A';

        this.accessRules.push({ label, value });
      });
    });

  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/user-type/user-type.component.ts